import { render, staticRenderFns } from "./app-version.vue?vue&type=template&id=0c86f315&"
import script from "./app-version.vue?vue&type=script&lang=ts&"
export * from "./app-version.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports